module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "multy-autocomplete",
    class: {
      'inline': _vm.$props.inline, 'focused': _vm.showSearch
    }
  }, [_c('div', {
    staticClass: "multy-autocomplete-container",
    class: {
      'has-error': (_vm.error || _vm.errors.has('isSelected')), 'focused': _vm.showSearch, 'has-value': (_vm.previewValue && _vm.previewValue.length), 'disabled': _vm.$props.disabled, 'readonly': _vm.$props.readonly
    }
  }, [(_vm.$props.label) ? _c('label', {
    attrs: {
      "for": _vm.$props.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$props.label + ((_vm.$props.required) ? '<span>*</span>' : '') + (_vm.$props.readonly ? ' (только для чтения)' : '') + (_vm.$props.loading ? ' (загрузка)' : ''))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "preview-container",
    class: {
      'disabled': _vm.$props.disabled, 'readonly': _vm.$props.readonly
    }
  }, [_c('div', {
    staticClass: "preview",
    class: {
      'can-add': _vm.$props.canAdd && !_vm.$props.disabled
    },
    attrs: {
      "placeholder": _vm.$props.placeholder
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_c('div', {
    staticClass: "value"
  }, _vm._l((_vm.previewValue), function(value) {
    return _c('span', {
      staticClass: "value-item"
    }, [_c('span', {
      staticClass: "value-item-span"
    }, [_vm._v(_vm._s(value.value))]), (_vm.getTooltip(value.item)) ? _c('span', {
      staticClass: "tolltip",
      domProps: {
        "innerHTML": _vm._s(_vm.getTooltip(value.item))
      }
    }) : _vm._e()])
  })), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchInput || _vm.findResult.length || _vm.selectedResult.length),
      expression: "showSearchInput || findResult.length || selectedResult.length"
    }],
    staticClass: "btn"
  })]), (!_vm.$props.disabled) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.canAdd && !_vm.showAdd),
      expression: "$props.canAdd && !showAdd"
    }],
    staticClass: "add-btn",
    on: {
      "click": _vm.showAddForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), (!_vm.$props.disabled) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.canAdd && _vm.showAdd),
      expression: "$props.canAdd && showAdd"
    }],
    staticClass: "add-btn",
    on: {
      "click": _vm.hideAddForm
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]) : _vm._e()]), _c('md-progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "md-accent",
    staticStyle: {
      "top": "46px",
      "height": "2px",
      "z-index": "900",
      "position": "absolute"
    },
    attrs: {
      "id": "progress-bar",
      "md-mode": "indeterminate"
    }
  })], 1), _c('div', {
    staticClass: "search-main-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch && (_vm.showSearchInput || _vm.findResult.length || _vm.selectedResult.length)),
      expression: "showSearch && (showSearchInput || findResult.length || selectedResult.length)"
    }],
    staticClass: "search-container"
  }, [(_vm.showSearchInput && !(this.$props.readonly || this.$props.disabled)) ? _c('z-input', {
    ref: "search",
    attrs: {
      "name": _vm.$props.name + '-search',
      "id": _vm.$props.id + '-search',
      "showLabel": false,
      "placeholder": "Поиск...",
      "loading": _vm.loading,
      "autocomplete": "off",
      "readonly": _vm.$props.readonly,
      "disabled": _vm.$props.disabled
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "showed-items"
  }, _vm._l((_vm.selectedResult), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "showed-item"
    }, [_c('div', {
      staticClass: "icon_container",
      on: {
        "click": function($event) {
          _vm.unselectItem(item, false)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    })]), _c('span', {
      on: {
        "click": function($event) {
          _vm.unselectItem(item, true)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.$props.displayProperty]))])])
  })), _c('div', {
    staticClass: "finded-items"
  }, _vm._l((_vm.findResult), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "finded-item"
    }, [_c('div', {
      staticClass: "icon_container",
      on: {
        "click": function($event) {
          _vm.selectItem(item, false)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    })]), _c('span', {
      on: {
        "click": function($event) {
          _vm.selectItem(item, true)
        }
      }
    }, [_vm._v(_vm._s(item[_vm.$props.displayProperty]))])])
  }))], 1)]), (_vm.error) ? _c('span', {
    staticClass: "md-error error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), (!_vm.error && _vm.errors.has('isSelected')) ? _c('span', {
    staticClass: "md-error error"
  }, [_vm._v("Необходимо выбрать значение из списка")]) : _vm._e(), (_vm.$props.canAdd && _vm.showAdd) ? _c('div', {
    staticClass: "new-entity"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e5f937f","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultyAutocomplete.vue
// module id = 1061
// module chunks = 0